"use strict";

var _slicedToArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/regenerator");

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(generateSpringForces),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(generateSpringForcesCompound),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(generateSpringElectricalForces),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(generateCompactnessForces),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(generateCenteringForces),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(generateNodeChildrenConstraints);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var optim_1 = require("../optim");

var gradients_1 = require("./gradients");
/**
 * Generates (1) attractive forces encouraging connected nodes to be no farther than their ideal
 * distance, and (2) repulsive forces between unconnected nodes encouraging them to be no closer
 * than their ideal distance. The ideal distance is the shortest path length scaled by the ideal
 * length. There are no forces generated between nodes of different connected components (with
 * undefined shortest path length).
 * @param storage
 * @param idealLength
 *     Ideal length of an edge between nodes, either as a constant or function of the nodes. The
 *     function will only be called between nodes with a non-undefined `shortestPath`.
 * @param shortestPath
 */


function generateSpringForces(storage, idealLength, shortestPath) {
  var config,
      _config$maxAttraction,
      maxAttraction,
      visited,
      _iteratorNormalCompletion,
      _didIteratorError,
      _iteratorError,
      _iterator,
      _step,
      u,
      siblings,
      _iteratorNormalCompletion2,
      _didIteratorError2,
      _iteratorError2,
      _iterator2,
      _step2,
      v,
      wu,
      wv,
      uvPath,
      idealDistance,
      axis,
      actualDistance,
      delta,
      _delta,
      _args = arguments;

  return _regeneratorRuntime.wrap(function generateSpringForces$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          config = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
          _config$maxAttraction = config.maxAttraction, maxAttraction = _config$maxAttraction === void 0 ? Infinity : _config$maxAttraction; // TODO: Replace idealLength and shortestPath, with idealLength: (u, v) => number | undefined.

          visited = new Set();
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 6;
          _iterator = storage.nodes()[Symbol.iterator]();

        case 8:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 60;
            break;
          }

          u = _step.value;
          visited.add(u);
          siblings = storage.siblings(u);
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context.prev = 15;
          _iterator2 = storage.nodes()[Symbol.iterator]();

        case 17:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context.next = 43;
            break;
          }

          v = _step2.value;

          if (!visited.has(v)) {
            _context.next = 21;
            break;
          }

          return _context.abrupt("continue", 40);

        case 21:
          if (!(u.fixed && v.fixed)) {
            _context.next = 23;
            break;
          }

          return _context.abrupt("continue", 40);

        case 23:
          wu = u.fixed ? 0 : 1, wv = v.fixed ? 0 : 1; // Forces act on only nodes that are not direct ancestors/descendants.

          uvPath = shortestPath(u, v);

          if (!(uvPath === undefined)) {
            _context.next = 27;
            break;
          }

          return _context.abrupt("continue", 40);

        case 27:
          // Ignore disconnected components.
          idealDistance = typeof idealLength === "function" ? uvPath * idealLength(u, v) : uvPath * idealLength;
          axis = new optim_1.Vector().subVectors(v.center, u.center);
          actualDistance = axis.length() > 0 ? u.shape.boundary(axis).distanceTo(v.shape.boundary(axis.negate())) : 0;

          if (!(actualDistance > idealDistance && storage.existsEdge(u, v, true) && !storage.hasAncestorOrDescendant(u, v))) {
            _context.next = 36;
            break;
          }

          // Attractive force between nodes with edges if too far. If one of them
          // contains the other, no force is exerted (between their centers).
          delta = Math.min(actualDistance - idealDistance, maxAttraction);
          _context.next = 34;
          return gradients_1.nudgePair(u.center, v.center, [-wu * delta, -wv * delta]);

        case 34:
          _context.next = 40;
          break;

        case 36:
          if (!(actualDistance < idealDistance && siblings.has(v))) {
            _context.next = 40;
            break;
          }

          // Repulsive force between node pairs if too close. Only siblings can repel each
          // other, else parents will repel their children, and children will be repelled by
          // the rest of graph rather than being isolated by the parent.
          _delta = (idealDistance - actualDistance) / Math.pow(uvPath, 2);
          _context.next = 40;
          return gradients_1.nudgePair(u.center, v.center, [wu * _delta, wv * _delta]);

        case 40:
          _iteratorNormalCompletion2 = true;
          _context.next = 17;
          break;

        case 43:
          _context.next = 49;
          break;

        case 45:
          _context.prev = 45;
          _context.t0 = _context["catch"](15);
          _didIteratorError2 = true;
          _iteratorError2 = _context.t0;

        case 49:
          _context.prev = 49;
          _context.prev = 50;

          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }

        case 52:
          _context.prev = 52;

          if (!_didIteratorError2) {
            _context.next = 55;
            break;
          }

          throw _iteratorError2;

        case 55:
          return _context.finish(52);

        case 56:
          return _context.finish(49);

        case 57:
          _iteratorNormalCompletion = true;
          _context.next = 8;
          break;

        case 60:
          _context.next = 66;
          break;

        case 62:
          _context.prev = 62;
          _context.t1 = _context["catch"](6);
          _didIteratorError = true;
          _iteratorError = _context.t1;

        case 66:
          _context.prev = 66;
          _context.prev = 67;

          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }

        case 69:
          _context.prev = 69;

          if (!_didIteratorError) {
            _context.next = 72;
            break;
          }

          throw _iteratorError;

        case 72:
          return _context.finish(69);

        case 73:
          return _context.finish(66);

        case 74:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[6, 62, 66, 74], [15, 45, 49, 57], [50,, 52, 56], [67,, 69, 73]]);
}

exports.generateSpringForces = generateSpringForces;

function generateSpringForcesCompound(storage, idealLength, shortestPath) {
  var config,
      _config$maxAttraction2,
      maxAttraction,
      visited,
      _iteratorNormalCompletion3,
      _didIteratorError3,
      _iteratorError3,
      _iterator3,
      _step3,
      u,
      _iteratorNormalCompletion5,
      _didIteratorError5,
      _iteratorError5,
      _iterator5,
      _step5,
      v,
      wu,
      wv,
      uvPath,
      idealDistance,
      axis,
      actualDistance,
      delta,
      _iteratorNormalCompletion4,
      _didIteratorError4,
      _iteratorError4,
      _iterator4,
      _step4,
      e,
      gda,
      _gda,
      _u,
      _v,
      _uvPath,
      _idealDistance,
      _axis,
      _actualDistance,
      _delta2,
      _args2 = arguments;

  return _regeneratorRuntime.wrap(function generateSpringForcesCompound$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          config = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
          _config$maxAttraction2 = config.maxAttraction, maxAttraction = _config$maxAttraction2 === void 0 ? Infinity : _config$maxAttraction2; // TODO: Replace idealLength and shortestPath, with idealLength: (u, v) => number | undefined.
          // Repulsive force between node pairs if too close. Only siblings can repel each
          // other, else parents will repel their children, and children will be repelled by
          // the rest of graph rather than being isolated by the parent.

          visited = new Set();
          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context2.prev = 6;
          _iterator3 = storage.nodes()[Symbol.iterator]();

        case 8:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context2.next = 53;
            break;
          }

          u = _step3.value;
          visited.add(u);
          _iteratorNormalCompletion5 = true;
          _didIteratorError5 = false;
          _iteratorError5 = undefined;
          _context2.prev = 14;
          _iterator5 = storage.siblings(u)[Symbol.iterator]();

        case 16:
          if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
            _context2.next = 36;
            break;
          }

          v = _step5.value;

          if (!visited.has(v)) {
            _context2.next = 20;
            break;
          }

          return _context2.abrupt("continue", 33);

        case 20:
          if (!(u.fixed && v.fixed)) {
            _context2.next = 22;
            break;
          }

          return _context2.abrupt("continue", 33);

        case 22:
          wu = u.fixed ? 0 : 1, wv = v.fixed ? 0 : 1;
          uvPath = shortestPath(u, v);

          if (!(uvPath === undefined)) {
            _context2.next = 26;
            break;
          }

          return _context2.abrupt("continue", 33);

        case 26:
          // Ignore disconnected components.
          idealDistance = typeof idealLength === "function" ? uvPath * idealLength(u, v) : uvPath * idealLength;
          axis = new optim_1.Vector().subVectors(v.center, u.center);
          actualDistance = axis.length() > 0 ? u.shape.boundary(axis).distanceTo(v.shape.boundary(axis.negate())) : 0;

          if (!(actualDistance < idealDistance)) {
            _context2.next = 33;
            break;
          }

          delta = (idealDistance - actualDistance) / Math.pow(uvPath, 2);
          _context2.next = 33;
          return gradients_1.nudgePair(u.center, v.center, [wu * delta, wv * delta]);

        case 33:
          _iteratorNormalCompletion5 = true;
          _context2.next = 16;
          break;

        case 36:
          _context2.next = 42;
          break;

        case 38:
          _context2.prev = 38;
          _context2.t0 = _context2["catch"](14);
          _didIteratorError5 = true;
          _iteratorError5 = _context2.t0;

        case 42:
          _context2.prev = 42;
          _context2.prev = 43;

          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }

        case 45:
          _context2.prev = 45;

          if (!_didIteratorError5) {
            _context2.next = 48;
            break;
          }

          throw _iteratorError5;

        case 48:
          return _context2.finish(45);

        case 49:
          return _context2.finish(42);

        case 50:
          _iteratorNormalCompletion3 = true;
          _context2.next = 8;
          break;

        case 53:
          _context2.next = 59;
          break;

        case 55:
          _context2.prev = 55;
          _context2.t1 = _context2["catch"](6);
          _didIteratorError3 = true;
          _iteratorError3 = _context2.t1;

        case 59:
          _context2.prev = 59;
          _context2.prev = 60;

          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }

        case 62:
          _context2.prev = 62;

          if (!_didIteratorError3) {
            _context2.next = 65;
            break;
          }

          throw _iteratorError3;

        case 65:
          return _context2.finish(62);

        case 66:
          return _context2.finish(59);

        case 67:
          // Attractive force between nodes with edges (directly or indirectly between descendants) if
          // too far. If one of them contains the other, no force between their centers is exerted.
          _iteratorNormalCompletion4 = true;
          _didIteratorError4 = false;
          _iteratorError4 = undefined;
          _context2.prev = 70;
          _iterator4 = storage.edges()[Symbol.iterator]();

        case 72:
          if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
            _context2.next = 94;
            break;
          }

          e = _step4.value;
          gda = storage.greatestDifferentAncestor(e.source.node, e.target.node);

          if (!(gda === undefined)) {
            _context2.next = 77;
            break;
          }

          return _context2.abrupt("continue", 91);

        case 77:
          _gda = _slicedToArray(gda, 2), _u = _gda[0], _v = _gda[1];

          if (!(_u.fixed && _v.fixed)) {
            _context2.next = 80;
            break;
          }

          return _context2.abrupt("continue", 91);

        case 80:
          wu = _u.fixed ? 0 : 1, wv = _v.fixed ? 0 : 1; // TODO: Is this right to ignore? What is the meaning of shortestPath?

          _uvPath = shortestPath(_u, _v);

          if (!(_uvPath === undefined)) {
            _context2.next = 84;
            break;
          }

          return _context2.abrupt("continue", 91);

        case 84:
          // Ignore disconnected components.
          _idealDistance = typeof idealLength === "function" ? idealLength(_u, _v) : idealLength;
          _axis = new optim_1.Vector().subVectors(_v.center, _u.center);
          _actualDistance = _axis.length() > 0 ? _u.shape.boundary(_axis).distanceTo(_v.shape.boundary(_axis.negate())) : 0;

          if (!(_actualDistance > _idealDistance)) {
            _context2.next = 91;
            break;
          }

          _delta2 = Math.min(_actualDistance - _idealDistance, maxAttraction);
          _context2.next = 91;
          return gradients_1.nudgePair(_u.center, _v.center, [-wu * _delta2, -wv * _delta2]);

        case 91:
          _iteratorNormalCompletion4 = true;
          _context2.next = 72;
          break;

        case 94:
          _context2.next = 100;
          break;

        case 96:
          _context2.prev = 96;
          _context2.t2 = _context2["catch"](70);
          _didIteratorError4 = true;
          _iteratorError4 = _context2.t2;

        case 100:
          _context2.prev = 100;
          _context2.prev = 101;

          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }

        case 103:
          _context2.prev = 103;

          if (!_didIteratorError4) {
            _context2.next = 106;
            break;
          }

          throw _iteratorError4;

        case 106:
          return _context2.finish(103);

        case 107:
          return _context2.finish(100);

        case 108:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[6, 55, 59, 67], [14, 38, 42, 50], [43,, 45, 49], [60,, 62, 66], [70, 96, 100, 108], [101,, 103, 107]]);
}

exports.generateSpringForcesCompound = generateSpringForcesCompound;
/**
 * Generates attractive forces encouraging edges to be no fthe ideal length and repulsive forces between
 * unconnected nodes proportional to their shortest path length. There are no forces generated
 * between forces from different connected components (with undefined shortest path length).
 * @param storage
 * @param idealLength
 *     Ideal length of an edge between nodes, either as a constant or function of the nodes. The
 *     function will only be called between nodes with a direct edge.
 * @param shortestPath
 */

function generateSpringElectricalForces(storage, idealLength, edgeStrength, repulsiveStrength) {
  var visited, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, u, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, v, wu, wv, axis, actualDistance, delta, _delta3;

  return _regeneratorRuntime.wrap(function generateSpringElectricalForces$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          visited = new Set();
          _iteratorNormalCompletion6 = true;
          _didIteratorError6 = false;
          _iteratorError6 = undefined;
          _context3.prev = 4;
          _iterator6 = storage.nodes()[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
            _context3.next = 55;
            break;
          }

          u = _step6.value;
          visited.add(u);
          _iteratorNormalCompletion7 = true;
          _didIteratorError7 = false;
          _iteratorError7 = undefined;
          _context3.prev = 12;
          _iterator7 = storage.nodes()[Symbol.iterator]();

        case 14:
          if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
            _context3.next = 38;
            break;
          }

          v = _step7.value;

          if (!visited.has(v)) {
            _context3.next = 18;
            break;
          }

          return _context3.abrupt("continue", 35);

        case 18:
          if (!(u.fixed && v.fixed)) {
            _context3.next = 20;
            break;
          }

          return _context3.abrupt("continue", 35);

        case 20:
          wu = u.fixed ? 0 : 1, wv = v.fixed ? 0 : 1; // Forces act on only nodes that are not direct ancestors/descendants.

          if (!(storage.hasAncestor(u, v) || storage.hasAncestor(v, u))) {
            _context3.next = 23;
            break;
          }

          return _context3.abrupt("continue", 35);

        case 23:
          if (typeof idealLength === "function") idealLength = idealLength(u, v);
          axis = new optim_1.Vector().subVectors(v.center, u.center);
          actualDistance = axis.length() > 0 ? u.shape.boundary(axis).distanceTo(v.shape.boundary(axis.negate())) : 1;

          if (!storage.existsEdge(u, v, true)) {
            _context3.next = 32;
            break;
          }

          // Restoring force between edges to ideal length.
          delta = edgeStrength * (actualDistance - idealLength);
          _context3.next = 30;
          return gradients_1.nudgePair(u.center, v.center, [-wu * delta, -wv * delta]);

        case 30:
          _context3.next = 35;
          break;

        case 32:
          // Repulsive force between unconnected node pairs.
          _delta3 = repulsiveStrength * Math.pow(actualDistance, -1);
          _context3.next = 35;
          return gradients_1.nudgePair(u.center, v.center, [wu * _delta3, wv * _delta3]);

        case 35:
          _iteratorNormalCompletion7 = true;
          _context3.next = 14;
          break;

        case 38:
          _context3.next = 44;
          break;

        case 40:
          _context3.prev = 40;
          _context3.t0 = _context3["catch"](12);
          _didIteratorError7 = true;
          _iteratorError7 = _context3.t0;

        case 44:
          _context3.prev = 44;
          _context3.prev = 45;

          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }

        case 47:
          _context3.prev = 47;

          if (!_didIteratorError7) {
            _context3.next = 50;
            break;
          }

          throw _iteratorError7;

        case 50:
          return _context3.finish(47);

        case 51:
          return _context3.finish(44);

        case 52:
          _iteratorNormalCompletion6 = true;
          _context3.next = 6;
          break;

        case 55:
          _context3.next = 61;
          break;

        case 57:
          _context3.prev = 57;
          _context3.t1 = _context3["catch"](4);
          _didIteratorError6 = true;
          _iteratorError6 = _context3.t1;

        case 61:
          _context3.prev = 61;
          _context3.prev = 62;

          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }

        case 64:
          _context3.prev = 64;

          if (!_didIteratorError6) {
            _context3.next = 67;
            break;
          }

          throw _iteratorError6;

        case 67:
          return _context3.finish(64);

        case 68:
          return _context3.finish(61);

        case 69:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[4, 57, 61, 69], [12, 40, 44, 52], [45,, 47, 51], [62,, 64, 68]]);
}

exports.generateSpringElectricalForces = generateSpringElectricalForces;
/**
 * Generates forces that pull children nodes towards the parent's center.
 * @param storage
 * @param strength
 */

function generateCompactnessForces(storage, strength) {
  var _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, u, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, child;

  return _regeneratorRuntime.wrap(function generateCompactnessForces$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          // TODO: Based on shape preserveSize, preserveWidth, preserveHeight
          _iteratorNormalCompletion8 = true;
          _didIteratorError8 = false;
          _iteratorError8 = undefined;
          _context4.prev = 3;
          _iterator8 = storage.nodes()[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
            _context4.next = 37;
            break;
          }

          u = _step8.value;
          _iteratorNormalCompletion9 = true;
          _didIteratorError9 = false;
          _iteratorError9 = undefined;
          _context4.prev = 10;
          _iterator9 = u.children[Symbol.iterator]();

        case 12:
          if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
            _context4.next = 19;
            break;
          }

          child = _step9.value;
          _context4.next = 16;
          return gradients_1.nudgePair(u.center, child.center, -strength);

        case 16:
          _iteratorNormalCompletion9 = true;
          _context4.next = 12;
          break;

        case 19:
          _context4.next = 25;
          break;

        case 21:
          _context4.prev = 21;
          _context4.t0 = _context4["catch"](10);
          _didIteratorError9 = true;
          _iteratorError9 = _context4.t0;

        case 25:
          _context4.prev = 25;
          _context4.prev = 26;

          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }

        case 28:
          _context4.prev = 28;

          if (!_didIteratorError9) {
            _context4.next = 31;
            break;
          }

          throw _iteratorError9;

        case 31:
          return _context4.finish(28);

        case 32:
          return _context4.finish(25);

        case 33:
          ;

        case 34:
          _iteratorNormalCompletion8 = true;
          _context4.next = 5;
          break;

        case 37:
          _context4.next = 43;
          break;

        case 39:
          _context4.prev = 39;
          _context4.t1 = _context4["catch"](3);
          _didIteratorError8 = true;
          _iteratorError8 = _context4.t1;

        case 43:
          _context4.prev = 43;
          _context4.prev = 44;

          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }

        case 46:
          _context4.prev = 46;

          if (!_didIteratorError8) {
            _context4.next = 49;
            break;
          }

          throw _iteratorError8;

        case 49:
          return _context4.finish(46);

        case 50:
          return _context4.finish(43);

        case 51:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[3, 39, 43, 51], [10, 21, 25, 33], [26,, 28, 32], [44,, 46, 50]]);
}

exports.generateCompactnessForces = generateCompactnessForces;
/**
 * Generates forces tha pull roots towards the origin.
 * @param storage
 * @param strength
 */

function generateCenteringForces(storage, strength) {
  var _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, r;

  return _regeneratorRuntime.wrap(function generateCenteringForces$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _iteratorNormalCompletion10 = true;
          _didIteratorError10 = false;
          _iteratorError10 = undefined;
          _context5.prev = 3;
          _iterator10 = storage.roots()[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
            _context5.next = 12;
            break;
          }

          r = _step10.value;
          _context5.next = 9;
          return gradients_1.nudgePoint(r.center, strength, [-r.center.x, -r.center.y]);

        case 9:
          _iteratorNormalCompletion10 = true;
          _context5.next = 5;
          break;

        case 12:
          _context5.next = 18;
          break;

        case 14:
          _context5.prev = 14;
          _context5.t0 = _context5["catch"](3);
          _didIteratorError10 = true;
          _iteratorError10 = _context5.t0;

        case 18:
          _context5.prev = 18;
          _context5.prev = 19;

          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }

        case 21:
          _context5.prev = 21;

          if (!_didIteratorError10) {
            _context5.next = 24;
            break;
          }

          throw _iteratorError10;

        case 24:
          return _context5.finish(21);

        case 25:
          return _context5.finish(18);

        case 26:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[3, 14, 18, 26], [19,, 21, 25]]);
}

exports.generateCenteringForces = generateCenteringForces;
/**
 * Constrain `u`'s children to be contained within itself, expansing its boundaries if necessary.
 * @param u
 *      Node with children to constrain.
 * @param padding
 *      Spacing inside the node's boundary.
 */

function generateNodeChildrenConstraints(u) {
  var padding,
      _args6 = arguments;
  return _regeneratorRuntime.wrap(function generateNodeChildrenConstraints$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          padding = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 0;

          if (!(u.children.length > 0)) {
            _context6.next = 4;
            break;
          }

          _context6.next = 4;
          return u.shape.constrainShapesWithin(u.children.map(function (child) {
            return child.shape;
          }), padding);

        case 4:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

exports.generateNodeChildrenConstraints = generateNodeChildrenConstraints;